import { createStore } from 'zustand-x';

export const bottomMenuStore = createStore('bottomMenu')(
  {
    isBottomMenuOpen: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  openBottomMenu: () => {
    set.isBottomMenuOpen(true);
  },
  closeBottomMenu: () => {
    set.isBottomMenuOpen(false);
  },
}));
